'use client';

import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { displayName } from 'react-quill';

import { UserInfoResposne } from '@/@types/api/user';
import { useUserStore } from '@/stores/useUserStore';

interface UserStoreInitializerProps {
  initialUser: UserInfoResposne | null;
}

export function UserStoreInitializer({
  initialUser,
}: UserStoreInitializerProps) {
  const { data: session } = useSession();

  useEffect(() => {
    console.log('UserStoreInitializer - Session:', session);
    console.log('UserStoreInitializer - Initial user:', initialUser);

    if (initialUser) {
      const userData = {
        user: {
          id: initialUser.id,
          email: initialUser.email,
          phoneNumber: initialUser.phoneNumber,
          phoneNumberVerified: initialUser.phoneNumberVerified,
          accountType: initialUser.accountType,
          accountCategory: initialUser.accountCategory,
          emailVerified: initialUser.emailVerified,
          username: initialUser.username || '',
          displayName: initialUser.displayName || '',
          iconUrl: initialUser.iconUrl || '',
          token: session?.user?.token || initialUser.token,
        },
        isLoggedIn: true,
        isInitialized: true,
      };
      console.log(
        'UserStoreInitializer - Setting store with user data:',
        userData,
      );
      useUserStore.setState(userData);
    } else {
      console.log('UserStoreInitializer - No user data, resetting store');
      useUserStore.setState({
        isInitialized: true,
        isLoggedIn: false,
        user: null,
      });
    }

    // Verify store state after initialization
    const storeState = useUserStore.getState();
    console.log(
      'UserStoreInitializer - Store state after initialization:',
      storeState,
    );

    // Cleanup function
    return () => {
      console.log('UserStoreInitializer - Cleaning up');
    };
  }, [initialUser, session]); // Re-run when initialUser or session changes

  return null;
}
